import { createContext, ReactNode, useState } from 'react'
import i18n from '../i18n'

interface LocaleContextType {
  locale: string
  setLocale: (language: string) => void
}

const defaultLocale = i18n.language.split('-')[0]
export const LocaleContext = createContext<LocaleContextType>({
  locale: defaultLocale,
  setLocale: () => {}, // replaced later by the provider
})

interface LanguageProviderProps {
  children: ReactNode
}

export const LocaleProvider = ({ children }: LanguageProviderProps) => {
  const [locale, setLocaleState] = useState(defaultLocale)

  const setLocale = (newLocale: string) => {
    setLocaleState(newLocale)
    i18n.changeLanguage(newLocale)
  }

  const value = { locale, setLocale }
  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  )
}
